<template>
  <section :id class="container my-spacing-lg">
    <div
      ref="root"
      class="block-datawrapper bg-white"
      :style
      :class="{
        'pointer-events-none': isEditing,
      }"
    >
      <div
        v-if="isEditing"
        class="flex size-full items-center justify-center p-6 text-center text-black"
      >
        <div>
          <p>Placeholder for Datawrapper:</p>
          <h3 class="text-size-4 font-bold">{{ title }}</h3>
          <p>
            Use the "Responsive Preview" in the top left to preview the
            visualisation.
          </p>
        </div>
      </div>
      <iframe
        v-else
        class="size-full"
        :title
        :src
        scrolling="no"
        frameborder="0"
        loading="lazy"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { CSSProperties } from 'vue'
import type { ParagraphDatawrapperFragment } from '#graphql-operations'
import { useElementSize, useEventListener } from '@vueuse/core'

const props = defineProps<ParagraphDatawrapperFragment>()

const isEditing = false

const { index, siblings } = defineBlokkli({
  bundle: 'datawrapper',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
})

const id = useParagraphAnchorId(index, siblings)

const root = ref<HTMLElement>()

const size = useElementSize(root)

const title = computed(() => props.media?.oembed?.title || props.media?.label)

const src = computed(() => props.media?.url)

const width = ref(props.media?.oembed?.width || 400)
const height = ref(props.media?.oembed?.height || 300)

const style = computed<CSSProperties>(() => {
  return {
    aspectRatio: `${width.value}/${height.value}`,
  }
})

if (import.meta.client) {
  useEventListener(window, 'message', function (e) {
    if (e.origin === 'https://datawrapper.dwcdn.net') {
      try {
        const data = e.data
        if (data && typeof data === 'string') {
          const json = JSON.parse(data)

          if (json.src === src.value && height.value !== json.height) {
            width.value = Math.round(size.width.value)
            height.value = Math.round(json.height)
          }
        }
      } catch {
        // Noop.
      }
    }
  })
}
</script>
